module.exports = __webpack_public_path__ + "img/right.83094e22.svg";